module.exports = __webpack_public_path__ + "static/media/afroamerican.c8d19be8.jpg";